import styled from 'styled-components';
import {ContentStyled} from '../../styles/components/content.style';
import {media} from '../../styles/components/media-queries';
import {H2, H3} from '../../styles/components/typography.style';

export const ContentWrapper = ContentStyled.extend`
  background: ${props => props.theme.reviewsPage.backgroundColor};
  text-align: left;
  width: ${props => props.theme.reviewsPage.width};
  margin-top: ${props => props.theme.reviewsPage.offsetTop};
  ${media.small`
    width: 100%;
    margin: 0;
  `};
  a {
    color: ${props => props.theme.linkColor};
  }
  li {
    list-style-type: none;
  }
  .TA_selfserveprop .widSSP {
    width: 100% !important;
  }
`;

export const H2Styled = H2.extend`
  margin-top: ${props => props.theme.margin};
  color: ${props => props.theme.primaryColor};
`;

export const H3Styled = H3.extend`
  color: ${props => props.theme.primaryColor};
`;

export const ReviewLinksStyled = styled.ul`
  text-align: center;
  padding: 0;
  li {
    display: inline-block;
    margin: 0 1rem;
  }
  a {
    color: ${props => props.theme.reviewsPage.linkColor};
  }
`;



// WEBPACK FOOTER //
// ./containers/ReviewsPage/ReviewsPage.style.js